document.addEventListener('DOMContentLoaded', function () {
    const pages = document.querySelectorAll('.regular-page--energy .regular-page__content');
    let svgCount = 0;

    if (pages.length === 0) return;

    function isDesktop() {
        return window.matchMedia('(min-width: 1024px)').matches;
    }

    function createSvg() {
        const svg   = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        const defs  = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        const beams = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        const instanceId = svgCount;
        const outerFilterId = 'regular-page-energy-beams-blur-outer-' + instanceId;
        const midFilterId = 'regular-page-energy-beams-blur-mid-' + instanceId;

        svgCount += 1;

        svg.classList.add('regular-page-energy-beams');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.dataset.energyBeamsId = instanceId;
        svg.dataset.blurOuterId = outerFilterId;
        svg.dataset.blurMidId = midFilterId;

        defs.append(
            createBlurFilter(outerFilterId, 18),
            createBlurFilter(midFilterId, 5)
        );

        beams.classList.add('regular-page-energy-beams__paths');
        svg.append(defs, beams);

        return svg;
    }

    function createBlurFilter(id, stdDeviation) {
        const filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
        const blur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');

        filter.setAttribute('id', id);
        filter.setAttribute('x', '-100%');
        filter.setAttribute('y', '-100%');
        filter.setAttribute('width', '300%');
        filter.setAttribute('height', '300%');
        blur.setAttribute('stdDeviation', stdDeviation);
        filter.append(blur);

        return filter;
    }

    function getMediaTargets(page) {
        return Array.from(page.querySelectorAll('.block-half-text-media__video, .block-half-text-media__picture'))
            .filter(function (target) {
                return target.offsetParent !== null;
            });
    }

    function getSectionTargets(page) {
        return Array.from(page.querySelectorAll('.block-half-text-media'))
            .filter(function (target) {
                return target.offsetParent !== null;
            });
    }

    function getBeamTargets(page) {
        if (!isDesktop()) {
            return getSectionTargets(page);
        }

        return getMediaTargets(page);
    }

    function getRelativeRect(element, containerRect) {
        const rect = element.getBoundingClientRect();

        return {
            left: rect.left - containerRect.left,
            right: rect.right - containerRect.left,
            top: rect.top - containerRect.top,
            bottom: rect.bottom - containerRect.top,
            width: rect.width,
            height: rect.height,
            centerX: rect.left - containerRect.left + rect.width / 2,
            centerY: rect.top - containerRect.top + rect.height / 2,
        };
    }

    function getConnectionPoint(fromRect, toRect, isStart) {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const fromLeft = fromRect.centerX < toRect.centerX;
        const direction = fromLeft ? 1 : -1;
        const xInset = fromRect.width * (isMobile ? 0.2 : 0.16);
        const yInset = fromRect.height * (isMobile ? 0.02 : 0.14);

        return {
            x: isStart ? fromRect.right - xInset : fromRect.left + xInset,
            y: isStart ? fromRect.bottom - yInset : fromRect.top + yInset,
            direction: direction,
        };
    }

    function getTopCenterPoint(fromRect, toRect) {
        const fromLeft = fromRect.centerX < toRect.centerX;

        return {
            x: toRect.centerX,
            y: toRect.top + toRect.height * 0.08,
            direction: fromLeft ? 1 : -1,
        };
    }

    function getFirstDesktopConnectionPoints(fromRect, toRect) {
        const xInset = fromRect.width * 0.16;
        const toXInset = toRect.width * 0.16;
        const yInset = fromRect.height * 0.14;
        const toYInset = toRect.height * 0.14;

        return {
            start: {
                x: fromRect.left + xInset,
                y: fromRect.bottom - yInset,
                direction: 1,
            },
            end: {
                x: toRect.right - toXInset,
                y: toRect.top + toYInset,
                direction: 1,
            },
        };
    }

    function getMobileConnectionPoints(fromRect, toRect, index) {
        const travelsRightToLeft = index % 2 === 0;
        const overlap = 60;
        const farAnchor = index === 0 ? 0.75 : 0.6;
        const nearAnchor = index === 0 ? 0.25 : 0.4;

        return {
            start: {
                x: travelsRightToLeft ? fromRect.left + fromRect.width * farAnchor : fromRect.left + fromRect.width * nearAnchor,
                y: fromRect.bottom - overlap,
                direction: travelsRightToLeft ? -1 : 1,
            },
            end: {
                x: travelsRightToLeft ? toRect.left + toRect.width * nearAnchor : toRect.left + toRect.width * farAnchor,
                y: toRect.top + overlap,
                direction: travelsRightToLeft ? -1 : 1,
            },
        };
    }

    function makeStraightPath(start, end) {
        return [
            'M', start.x.toFixed(1), start.y.toFixed(1),
            'L', end.x.toFixed(1), end.y.toFixed(1),
        ].join(' ');
    }

    function makePath(start, end, options) {
        const shouldForceStraight = options && options.forceStraight;
        const minCurveSpace = window.matchMedia('(max-width: 1279px)').matches ? 340 : 260;
        const xSpace = Math.abs(end.x - start.x);
        const ySpace = Math.abs(end.y - start.y);

        if (shouldForceStraight || xSpace < minCurveSpace || ySpace < 150 || xSpace / ySpace < 0.3 || ySpace / xSpace < 0.2) {
            return makeStraightPath(start, end);
        }

        const dx = end.x - start.x;
        const dy = end.y - start.y;
        const yDirection = dy >= 0 ? 1 : -1;
        const xDirection = dx >= 0 ? 1 : -1;
        const bendLength = Math.min(90, xSpace * 0.18, ySpace * 0.28);
        const exitPoint = {
            x: start.x + xDirection * bendLength,
            y: start.y + yDirection * bendLength,
        };
        const entryPoint = {
            x: end.x - xDirection * bendLength,
            y: end.y - yDirection * bendLength,
        };

        return [
            'M', start.x.toFixed(1), start.y.toFixed(1),
            'C', start.x.toFixed(1), (start.y + yDirection * bendLength).toFixed(1),
            (start.x + xDirection * bendLength).toFixed(1), exitPoint.y.toFixed(1),
            exitPoint.x.toFixed(1), exitPoint.y.toFixed(1),
            'L', entryPoint.x.toFixed(1), entryPoint.y.toFixed(1),
            'C', (end.x - xDirection * bendLength).toFixed(1), entryPoint.y.toFixed(1),
            end.x.toFixed(1), (end.y - yDirection * bendLength).toFixed(1),
            end.x.toFixed(1), end.y.toFixed(1),
        ].join(' ');
    }

    function clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
    }

    function makeMobilePath(start, end, index, pageWidth) {
        const dy = end.y - start.y;
        const dx = end.x - start.x;
        const direction = dx >= 0 ? 1 : -1;
        const yDirection = dy >= 0 ? 1 : -1;
        const stemLength = clamp(Math.abs(dy) * 0.16, 28, 56);
        const bendHeight = clamp(Math.abs(dy) * 0.18, 38, 72);
        const bendWidth = clamp(Math.abs(dx) * 0.28, 52, 96);
        const exitPoint = {
            x: start.x,
            y: start.y + yDirection * stemLength,
        };
        const entryPoint = {
            x: end.x,
            y: end.y - yDirection * stemLength,
        };
        let lineStart = {
            x: start.x + direction * bendWidth,
            y: exitPoint.y + yDirection * bendHeight,
        };
        let lineEnd = {
            x: end.x - direction * bendWidth,
            y: entryPoint.y - yDirection * bendHeight,
        };

        if (yDirection > 0 && lineStart.y > lineEnd.y - 24 || yDirection < 0 && lineStart.y < lineEnd.y + 24) {
            lineStart = {
                x: lineStart.x,
                y: start.y + dy * 0.36,
            };
            lineEnd = {
                x: lineEnd.x,
                y: start.y + dy * 0.64,
            };
        }

        const lineDx = lineEnd.x - lineStart.x;
        const lineDy = lineEnd.y - lineStart.y;
        const lineLength = Math.hypot(lineDx, lineDy) || 1;
        const lineUnit = {
            x: lineDx / lineLength,
            y: lineDy / lineLength,
        };
        const lineHandle = Math.min(78, Math.max(42, lineLength * 0.18));
        const exitControl1 = {
            x: exitPoint.x,
            y: exitPoint.y + yDirection * bendHeight * 0.55,
        };
        const exitControl2 = {
            x: lineStart.x - lineUnit.x * lineHandle,
            y: lineStart.y - lineUnit.y * lineHandle,
        };
        const entryControl1 = {
            x: lineEnd.x + lineUnit.x * lineHandle,
            y: lineEnd.y + lineUnit.y * lineHandle,
        };
        const entryControl2 = {
            x: entryPoint.x,
            y: entryPoint.y - yDirection * bendHeight * 0.55,
        };

        return [
            'M', start.x.toFixed(1), start.y.toFixed(1),
            'L', exitPoint.x.toFixed(1), exitPoint.y.toFixed(1),
            'C', exitControl1.x.toFixed(1), exitControl1.y.toFixed(1),
            exitControl2.x.toFixed(1), exitControl2.y.toFixed(1),
            lineStart.x.toFixed(1), lineStart.y.toFixed(1),
            'L', lineEnd.x.toFixed(1), lineEnd.y.toFixed(1),
            'C', entryControl1.x.toFixed(1), entryControl1.y.toFixed(1),
            entryControl2.x.toFixed(1), entryControl2.y.toFixed(1),
            entryPoint.x.toFixed(1), entryPoint.y.toFixed(1),
            'L', end.x.toFixed(1), end.y.toFixed(1),
        ].join(' ');
    }

    function createGradient(id, start, end) {
        const gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
        const stops = [
            { offset: '0%', color: '#00DDFF', opacity: '0' },
            { offset: '18%', color: '#00DDFF', opacity: '0.9' },
            { offset: '45%', color: '#00DDFF', opacity: '1' },
            { offset: '82%', color: '#0036FC', opacity: '0.9' },
            { offset: '100%', color: '#0036FC', opacity: '0' },
        ];

        gradient.setAttribute('id', id);
        gradient.setAttribute('gradientUnits', 'userSpaceOnUse');
        gradient.setAttribute('x1', start.x.toFixed(1));
        gradient.setAttribute('y1', start.y.toFixed(1));
        gradient.setAttribute('x2', end.x.toFixed(1));
        gradient.setAttribute('y2', end.y.toFixed(1));

        stops.forEach(function (stopData) {
            const stop = document.createElementNS('http://www.w3.org/2000/svg', 'stop');

            stop.setAttribute('offset', stopData.offset);
            stop.setAttribute('stop-color', stopData.color);
            stop.setAttribute('stop-opacity', stopData.opacity);
            gradient.append(stop);
        });

        return gradient;
    }

    function createGradientStop(offset, color, opacity, animationValues, duration, delay) {
        const stop = document.createElementNS('http://www.w3.org/2000/svg', 'stop');

        stop.setAttribute('offset', offset);
        stop.setAttribute('stop-color', color);
        stop.setAttribute('stop-opacity', opacity);

        if (animationValues) {
            const animate = document.createElementNS('http://www.w3.org/2000/svg', 'animate');

            animate.setAttribute('attributeName', 'offset');
            animate.setAttribute('dur', duration);
            animate.setAttribute('begin', delay);
            animate.setAttribute('values', animationValues);
            animate.setAttribute('repeatCount', 'indefinite');
            animate.setAttribute('calcMode', 'spline');
            animate.setAttribute('keyTimes', '0;0.45;0.85;1');
            animate.setAttribute('keySplines', '0.4 0 0.2 1;0.4 0 0.2 1;0.4 0 0.2 1');
            stop.append(animate);
        }

        return stop;
    }

    function createSweepGradient(id, start, end, index) {
        const gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
        const duration = '5.8s';
        const delay = (-1.1 * index).toFixed(1) + 's';

        gradient.setAttribute('id', id);
        gradient.setAttribute('gradientUnits', 'userSpaceOnUse');
        gradient.setAttribute('x1', start.x.toFixed(1));
        gradient.setAttribute('y1', start.y.toFixed(1));
        gradient.setAttribute('x2', end.x.toFixed(1));
        gradient.setAttribute('y2', end.y.toFixed(1));

        gradient.append(
            createGradientStop('0%', '#8DF7FF', '0', '0;0.18;0.62;1', duration, delay),
            createGradientStop('4%', '#8DF7FF', '0', '0.04;0.28;0.72;1', duration, delay),
            createGradientStop('9%', '#A9F6FF', '0.9', '0.09;0.38;0.82;1', duration, delay),
            createGradientStop('15%', '#00DDFF', '0.75', '0.15;0.48;0.92;1', duration, delay),
            createGradientStop('24%', '#00DDFF', '0', '0.24;0.62;1;1', duration, delay)
        );

        return gradient;
    }

    function createPath(className, d, stroke, filterId, animationDelay) {
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

        path.classList.add('regular-page-energy-beams__path', className);
        path.setAttribute('d', d);
        path.setAttribute('stroke', stroke);

        if (filterId) {
            path.setAttribute('filter', 'url(#' + filterId + ')');
        }

        if (animationDelay) {
            path.style.setProperty('--energy-glow-delay', animationDelay);
        }

        return path;
    }

    function createBeamLayers(svg, d, gradientId, sweepGradientId, index) {
        const stroke = 'url(#' + gradientId + ')';
        const sweepStroke = 'url(#' + sweepGradientId + ')';
        const outerDelay = (-0.9 * index).toFixed(1) + 's';
        const midDelay = (-0.9 * index - 1.4).toFixed(1) + 's';

        return [
            createPath('regular-page-energy-beams__path--glow-outer', d, stroke, svg.dataset.blurOuterId, outerDelay),
            createPath('regular-page-energy-beams__path--glow-mid', d, stroke, svg.dataset.blurMidId, midDelay),
            createPath('regular-page-energy-beams__path--trace', d, stroke),
            createPath('regular-page-energy-beams__path--sweep', d, sweepStroke),
        ];
    }

    function seededRandom(seed) {
        const x = Math.sin(seed) * 10000;

        return x - Math.floor(x);
    }

    function createEnergyParticles(path, pathIndex) {
        const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        let pathLength = 0;

        group.classList.add('regular-page-energy-beams__particles');

        try {
            pathLength = path.getTotalLength();
        } catch (error) {
            return group;
        }

        const particleCount = Math.max(24, Math.min(72, Math.round(pathLength / 18)));

        for (let i = 0; i < particleCount; i += 1) {
            const seed = (pathIndex + 1) * 1000 + i * 17;
            const progress = 0.08 + seededRandom(seed) * 0.84;
            const distance = progress * pathLength;
            const point = path.getPointAtLength(distance);
            const before = path.getPointAtLength(Math.max(0, distance - 1));
            const after = path.getPointAtLength(Math.min(pathLength, distance + 1));
            const dx = after.x - before.x;
            const dy = after.y - before.y;
            const angle = Math.atan2(dy, dx) + Math.PI / 2;
            const side = seededRandom(seed + 3) > 0.5 ? 1 : -1;
            const edgeDistance = 1.7 + seededRandom(seed + 5) * 3.4;
            const spread = side * edgeDistance + (seededRandom(seed + 7) - 0.5) * 1.8;
            const along = (seededRandom(seed + 9) - 0.5) * 5;
            const radius = 0.25 + seededRandom(seed + 11) * 0.75;
            const endFade = Math.min(1, progress / 0.18, (1 - progress) / 0.18);
            const opacity = (0.24 + seededRandom(seed + 13) * 0.5) * endFade;
            const particle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');

            particle.classList.add('regular-page-energy-beams__particle');
            particle.setAttribute('cx', (point.x + Math.cos(angle) * spread + Math.cos(angle - Math.PI / 2) * along).toFixed(1));
            particle.setAttribute('cy', (point.y + Math.sin(angle) * spread + Math.sin(angle - Math.PI / 2) * along).toFixed(1));
            particle.setAttribute('r', radius.toFixed(2));
            particle.style.setProperty('--energy-particle-opacity', opacity.toFixed(2));
            particle.style.setProperty('--energy-particle-opacity-mid', (opacity * 0.55).toFixed(2));
            particle.style.setProperty('--energy-particle-opacity-low', (opacity * 0.25).toFixed(2));
            particle.style.setProperty('--energy-particle-delay', (-seededRandom(seed + 17) * 3.8).toFixed(2) + 's');
            particle.style.setProperty('--energy-particle-duration', (2.1 + seededRandom(seed + 19) * 2.4).toFixed(2) + 's');
            group.append(particle);
        }

        return group;
    }

    function renderPageBeams(page, svg) {
        const targets = getBeamTargets(page);
        const defs = svg.querySelector('defs');
        const paths = svg.querySelector('.regular-page-energy-beams__paths');
        const containerRect = page.getBoundingClientRect();
        const pageTop = containerRect.top + window.scrollY;
        const pageLeft = containerRect.left + window.scrollX;
        const pageWidth = page.scrollWidth;
        const pageHeight = page.scrollHeight;

        svg.setAttribute('viewBox', '0 0 ' + pageWidth + ' ' + pageHeight);
        svg.setAttribute('width', pageWidth);
        svg.setAttribute('height', pageHeight);
        svg.style.top = pageTop.toFixed(1) + 'px';
        svg.style.left = pageLeft.toFixed(1) + 'px';
        svg.style.width = pageWidth + 'px';
        svg.style.height = pageHeight + 'px';
        paths.innerHTML = '';
        defs.querySelectorAll('linearGradient').forEach(function (gradient) {
            gradient.remove();
        });

        if (targets.length < 2) {
            page.classList.remove('regular-page__content--has-energy-beams');
            svg.classList.remove('regular-page-energy-beams--is-visible');
            svg.hidden = true;
            return;
        }

        svg.hidden = false;
        if (!svg.classList.contains('regular-page-energy-beams--is-visible')) {
            window.requestAnimationFrame(function () {
                svg.classList.add('regular-page-energy-beams--is-visible');
            });
        }
        page.classList.add('regular-page__content--has-energy-beams');

        targets.forEach(function (target, index) {
            const nextTarget = targets[index + 1];
            const desktop = isDesktop();

            if (!nextTarget) return;

            const fromRect = getRelativeRect(target, containerRect);
            const toRect = getRelativeRect(nextTarget, containerRect);
            const mobilePoints = desktop ? null : getMobileConnectionPoints(fromRect, toRect, index);
            const firstDesktopPoints = desktop && index === 0 ? getFirstDesktopConnectionPoints(fromRect, toRect) : null;
            const start = desktop
                ? (firstDesktopPoints ? firstDesktopPoints.start : getConnectionPoint(fromRect, toRect, true))
                : mobilePoints.start;
            const end = desktop
                ? (firstDesktopPoints ? firstDesktopPoints.end : getConnectionPoint(toRect, fromRect, false))
                : mobilePoints.end;
            const d = desktop
                ? makePath(start, end, {
                    forceStraight: true,
                })
                : makeStraightPath(start, end);
            const gradientId = 'regular-page-energy-beams-gradient-' + svg.dataset.energyBeamsId + '-' + index;
            const sweepGradientId = 'regular-page-energy-beams-sweep-gradient-' + svg.dataset.energyBeamsId + '-' + index;
            const layers = createBeamLayers(svg, d, gradientId, sweepGradientId, index);

            defs.append(createGradient(gradientId, start, end));
            defs.append(createSweepGradient(sweepGradientId, start, end, index));
            paths.append(...layers);
            paths.append(createEnergyParticles(layers[2], index));
        });
    }

    function setupPage(page) {
        const svg = createSvg();
        let frame = null;

        document.body.append(svg);

        function requestRender() {
            if (frame) {
                window.cancelAnimationFrame(frame);
            }

            frame = window.requestAnimationFrame(function () {
                renderPageBeams(page, svg);
                frame = null;
            });
        }

        requestRender();

        window.addEventListener('resize', requestRender, { passive: true });
        window.addEventListener('load', requestRender, { once: true });

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(requestRender);
        }

        page.querySelectorAll('img, video').forEach(function (media) {
            media.addEventListener('load', requestRender, { once: true });
            media.addEventListener('loadedmetadata', requestRender, { once: true });
        });

        if (typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(requestRender);
            observer.observe(page);
            getMediaTargets(page).forEach(function (target) {
                observer.observe(target);
            });
            getSectionTargets(page).forEach(function (target) {
                observer.observe(target);
            });
        }
    }

    pages.forEach(function (page) {
        setupPage(page);
    });
});
